import * as React from 'react';
import { ReactNode } from 'react';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

export const tooltipSizes = {
    padding: {
        small: '4px 8px',
        medium: '8px 12px',
        large: '12px',
    },
} as { padding: Record<string, string> };

export type TooltipSizes = keyof typeof tooltipSizes.padding;

const Tooltip = styled((props) => <ReactTooltip {...props} />)<{ sizeTooltip: TooltipSizes }>`
    &&& {
        padding: ${(props) => tooltipSizes.padding[props.sizeTooltip]};
        max-width: 360px;
        opacity: 1;
        border-radius: 8px;
        z-index: ${({ theme }) => theme.zIndex.tooltip};
    }

    &&&:before {
        z-index: -1;
    }
`;

export type JRCBaseTooltipProps = {
    tooltip: any;
    children: ReactNode;
    dataEventOff: 'click' | 'mouseleave';
    description?: string;
    className?: string;
    color: {
        border?: string;
        background: string;
        text: string;
    };
    sizeTooltip: 'small' | 'medium' | 'large';
    position?: 'top' | 'bottom' | 'left' | 'right';
    delayHide?: number;
    delayShow?: number;
    events?: any;
    asBlock?: boolean;
};

const Block = styled.div``;
const Span = styled.span``;
const InlineBlock = styled.span`
    display: inline-block;
`;

export const JRCBaseTooltip = (props: JRCBaseTooltipProps) => {
    const id = uuidv4();
    const Container = props.asBlock ? Block : Span;
    const SubContainer = props.asBlock ? Block : InlineBlock;

    return (
        <Container className={props.className}>
            <SubContainer
                aria-describedby={id}
                data-event={props.events}
                data-event-off={props.dataEventOff}
                data-tip
                data-for={id}
                className="tooltip-source">
                {props.children}
            </SubContainer>
            <Tooltip
                effect="solid"
                role="tooltip"
                id={id}
                place={props.position || 'bottom'}
                backgroundColor={props.color.background}
                borderColor={props.color.border}
                border={!!props.color.border}
                textColor={props.color.text}
                clickable
                globalEventOff="click"
                scrollHide={true}
                resizeHide={true}
                sizeTooltip={props.sizeTooltip}
                delayHide={props.delayHide}
                delayShow={props.delayShow}
                className="tooltip-wrapper"
                aria-label={props.description}>
                {props.tooltip()}
            </Tooltip>
        </Container>
    );
};
